<section *ngIf="stackedZoneDisplayFlags?.displayOnMobile" class="bubble-card-section cbolui-cds">
    <cds-accordion2
        [multi]="true"
        class="bubble-card-section__accordion"
    >
      <cds-accordion2-section
        *ngFor="let section of headerContent?.mobileStackedSwipeZone;let i = index"
        [(isOpen)]="accordionStatus[i]"
        icon="Right"
        class="bubble-card-section__accordion__section"
        (sectionClicked)="onTagging(section?.taggingTitle || section?.text, i)"
      >
        <div cdsAccordion2Header [innerHTML]="section?.text | safeHtml"></div>
        <div [innerHTML]="section?.description | safeHtml"></div>
        </cds-accordion2-section>
    </cds-accordion2>
</section>
